import { useLatest } from 'ahooks';
import * as React from 'react';
import { useEffect, useState } from 'react';

type CurrentStep = number | undefined;
export const guideZIndex = 99999;

const _event = 'GUIDE';
function customUserEvent(key: 'currentStep', value: CurrentStep) {
  var event: any = new Event(_event);
  event.key = key;
  event.newValue = value;
  window.dispatchEvent(event);
}

export interface Step {
  selector: string;
  content: React.ReactNode;
  label: string;
  position: 'left' | 'right' | 'bottom';
  padding?: {
    x?: number;
    y?: number;
  };
}
export const steps: {
  [step: number]: Step;
} = {};

let currentStep: CurrentStep;
const getCurrentStep = (): CurrentStep => {
  return currentStep;
};
export const setCurrentStep = (_currentStep: CurrentStep) => {
  currentStep = _currentStep;
  customUserEvent('currentStep', _currentStep);
};

export const addEventListener = (
  eventFn: (currentStep: CurrentStep, e?: Event) => void
): Function => {
  function _eventFn(e: Event) {
    window.setTimeout(() => {
      eventFn(getCurrentStep(), e);
    });
  }

  //当前tab页有效
  window.addEventListener(_event, _eventFn);
  return () => {
    window.removeEventListener(_event, _eventFn);
  };
};

export const useGuide = (): { currentStep: CurrentStep } => {
  const [currentStep, setCurrentStep] = useState(getCurrentStep());
  const latestCurrentStep = useLatest(currentStep);
  useEffect(() => {
    const removeEventListener = addEventListener((newCurrentStep, e) => {
      if (newCurrentStep !== latestCurrentStep.current) {
        setCurrentStep(newCurrentStep);
      }
    });
    return () => {
      removeEventListener();
    };
  }, []);
  return { currentStep };
};

export * from './guide';
export * from './guideItem';
